import { render, staticRenderFns } from "./ProjectWireframeCard.vue?vue&type=template&id=19c1dcac&scoped=true&"
import script from "./ProjectWireframeCard.vue?vue&type=script&lang=js&"
export * from "./ProjectWireframeCard.vue?vue&type=script&lang=js&"
import style0 from "./ProjectWireframeCard.vue?vue&type=style&index=0&id=19c1dcac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c1dcac",
  null
  
)

export default component.exports